// SPV Pool v1.0 PR 6 — Cash Flow period selector. A controlled toggle
// group (Monthly | Quarterly | Annual). Switching the period type resets
// the resolved date range to the current month / quarter / year.
// Range resolution lives in ./periodRange so this file only exports a
// component (React Fast Refresh constraint).

import { Button } from "@/design-system/components/ui";
import { cn } from "@/design-system/lib/utils";
import { CASH_FLOW_PERIODS, type CashFlowPeriod } from "@/types/spvPool";

interface PeriodSelectorProps {
  period: CashFlowPeriod;
  onChange: (period: CashFlowPeriod) => void;
}

export function PeriodSelector({ period, onChange }: PeriodSelectorProps) {
  return (
    <div
      className="inline-flex items-center gap-space-1"
      role="group"
      aria-label="Cash flow period"
    >
      {CASH_FLOW_PERIODS.map((p) => {
        const active = p === period;
        return (
          <Button
            key={p}
            type="button"
            size="sm"
            variant={active ? "primary" : "secondary"}
            aria-pressed={active}
            className={cn(active && "font-semibold")}
            onClick={() => onChange(p)}
          >
            {p}
          </Button>
        );
      })}
    </div>
  );
}
